import { useSession } from '@/lib/session';
import { Badge, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@iq/ui';
import { useTranslation } from 'react-i18next';

export function ProfileSection() {
  const { t } = useTranslation();
  const session = useSession();

  if (session.status !== 'authenticated') {
    return null;
  }

  const { email, name, role, locale } = session.session;
  return (
    <Card data-testid="settings-profile">
      <CardHeader>
        <CardTitle>{t('settings.profile.title')}</CardTitle>
        <CardDescription>{t('settings.profile.subtitle')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <Row label={t('settings.profile.email')} value={email} />
        {name ? <Row label={t('settings.profile.name')} value={name} /> : null}
        <Row label={t('settings.profile.role')} value={<Badge variant="secondary">{role}</Badge>} />
        <Row
          label={t('settings.profile.locale')}
          value={<Badge variant="outline">{locale.toUpperCase()}</Badge>}
        />
      </CardContent>
    </Card>
  );
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <span className="text-muted-foreground">{label}</span>
      <span className="break-words font-medium sm:text-right">{value}</span>
    </div>
  );
}
